import { z } from 'zod';
import { contentIdSchema, pathSchema } from './content-id.js';
import { provenanceSourceSchema } from './provenance.js';
/**
 * Ошибки расчёта.
 *
 * Схема здесь, а не в `packages/rules`, потому что ошибка расчёта
 * доезжает до клиента: интерфейс обязан показать, что именно
 * не сошлось (CLAUDE.md, п. 6). Текст сообщения собирается
 * в интерфейсе по коду и полям, как и провенанс (D11).
 */
export const calcErrorSchema = z.discriminatedUnion('code', [
    /** Путь, которого нет в контексте расчёта (rules-engine.md, раздел 4). */
    z.strictObject({ code: z.literal('unknown-path'), path: pathSchema }),
    /** Ссылка по кругу: цепочка приводится целиком, чтобы было видно круг. */
    z.strictObject({
        code: z.literal('cyclic-ref'),
        chain: z.array(pathSchema).min(2),
    }),
    /** Несколько `set` на одну величину (D18.3): перечисляем спорящих. */
    z.strictObject({
        code: z.literal('conflicting-set'),
        target: pathSchema,
        sources: z.array(provenanceSourceSchema).min(2),
    }),
    /** У величины есть прибавки, но нет базы: `set` не задал никто. */
    z.strictObject({ code: z.literal('missing-base'), target: pathSchema }),
    /** Два шага журнала с одним `step_index`: порядок свёртки неоднозначен. */
    z.strictObject({
        code: z.literal('duplicate-step'),
        stepIndex: z.number().int().nonnegative(),
    }),
    /** Контент, на который ссылаются журнал или состояние, не передан. */
    z.strictObject({ code: z.literal('unknown-content'), id: contentIdSchema }),
    /**
     * Над величиной смешаны операции разного вида: числовые и `grant`
     * (D21.3). Признак нельзя умножить, число нельзя добавить в набор.
     */
    z.strictObject({
        code: z.literal('unexpected-target-kind'),
        target: pathSchema,
        expected: z.enum(['number', 'traits']),
    }),
    /** Значение в контексте есть, но не того вида, что нужно операции. */
    z.strictObject({
        code: z.literal('unexpected-context-value'),
        path: pathSchema,
        expected: z.enum(['number', 'scalar', 'list']),
    }),
]);
//# sourceMappingURL=errors.js.map